"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _createApi = require("../../createApi");

var FeatureApi = function (_BaseApi) {
  (0, _inherits2["default"])(FeatureApi, _BaseApi);

  function FeatureApi(baseUrl) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      baseUrl: baseUrl
    };
    var apiInstance = arguments.length > 2 ? arguments[2] : undefined;
    (0, _classCallCheck2["default"])(this, FeatureApi);
    return (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(FeatureApi).call(this, baseUrl, options, apiInstance));
  }

  (0, _createClass2["default"])(FeatureApi, [{
    key: "createFeature",
    value: function createFeature(_ref) {
      var clientId = _ref.clientId,
          data = _ref.data;
      return this.api.post("/clients/".concat(clientId, "/features"), {
        data: data
      });
    }
  }, {
    key: "createFeatureVariant",
    value: function createFeatureVariant(_ref2) {
      var clientId = _ref2.clientId,
          groupIds = _ref2.groupIds,
          data = _ref2.data;
      return this.api.post("/clients/".concat(clientId, "/features"), {
        params: {
          groupIds: groupIds
        },
        data: data
      });
    }
  }, {
    key: "getFeatures",
    value: function getFeatures(_ref3) {
      var clientId = _ref3.clientId,
          groupId = _ref3.groupId;
      return groupId ? this.api.get("/clients/".concat(clientId, "/groups/").concat(groupId, "/features")) : this.api.get("/clients/".concat(clientId, "/features"));
    }
  }, {
    key: "getFeatureVariants",
    value: function getFeatureVariants(_ref4) {
      var clientId = _ref4.clientId,
          featureId = _ref4.featureId,
          _ref4$skip = _ref4.skip,
          skip = _ref4$skip === void 0 ? 0 : _ref4$skip,
          _ref4$limit = _ref4.limit,
          limit = _ref4$limit === void 0 ? 20 : _ref4$limit;
      return this.api.get("/clients/".concat(clientId, "/features/").concat(featureId, "/groups"), {
        params: {
          skip: skip,
          limit: limit
        }
      });
    }
  }, {
    key: "getFeaturesWithDefinition",
    value: function getFeaturesWithDefinition() {
      return this.api.get("/features/definition/");
    }
  }, {
    key: "getFeaturesConfig",
    value: function getFeaturesConfig(_ref5) {
      var clientId = _ref5.clientId;
      return this.api.get('/features', {
        params: {
          clientId: clientId
        }
      });
    }
  }, {
    key: "updateFeature",
    value: function updateFeature(_ref6) {
      var clientId = _ref6.clientId,
          id = _ref6.id,
          data = _ref6.data;
      return this.api.put("/clients/".concat(clientId, "/features/").concat(id), {
        data: data
      });
    }
  }, {
    key: "updateGroupFeature",
    value: function updateGroupFeature(_ref7) {
      var clientId = _ref7.clientId,
          groupId = _ref7.groupId,
          id = _ref7.id,
          data = _ref7.data;
      return this.api.put("/clients/".concat(clientId, "/groups/").concat(groupId, "/features/").concat(id), {
        data: data
      });
    }
  }, {
    key: "updateFeatureStatus",
    value: function updateFeatureStatus(_ref8) {
      var clientId = _ref8.clientId,
          id = _ref8.id,
          data = _ref8.data;
      return this.api.put("/clients/".concat(clientId, "/features/").concat(id, "/status"), {
        data: data
      });
    }
  }, {
    key: "updateGroupFeatureStatus",
    value: function updateGroupFeatureStatus(_ref9) {
      var groupId = _ref9.groupId,
          clientId = _ref9.clientId,
          id = _ref9.id,
          data = _ref9.data;
      return this.api.put("/clients/".concat(clientId, "/groups/").concat(groupId, "/features/").concat(id, "/status"), {
        data: data
      });
    }
  }, {
    key: "deleteFeatureVariant",
    value: function deleteFeatureVariant(_ref10) {
      var groupId = _ref10.groupId,
          clientId = _ref10.clientId,
          id = _ref10.id;
      return this.api["delete"]("/clients/".concat(clientId, "/groups/").concat(groupId, "/features/").concat(id));
    }
  }]);
  return FeatureApi;
}(_createApi.BaseApi);

var _default = FeatureApi;
exports["default"] = _default;
//# sourceMappingURL=index.js.map